// extracted by mini-css-extract-plugin
export default {"input":"GlobalFooter_input__a7Mjj","global_footer":"GlobalFooter_global_footer__IOgpg"};